import { string } from 'prop-types';
import styled from 'styled-components';

const Image = styled.img`
  display: block;
  max-height: ${({ height }) => height};
  margin: ${({ margin }) => (margin ? margin : 'initial')};
`;

const StyledImage = ({ href, ...args }) => {
  const renderImage = () => <Image {...args} />;

  if (href) {
    return (
      <a target="_blank" rel="noopener noreferrer" href={href}>
        {renderImage()}
      </a>
    );
  }

  return renderImage();
};

StyledImage.propTypes = {
  width: string,
  href: string,
  height: string,
  margin: string,
  borderRadius: string,
  src: string.isRequired,
};

export default StyledImage;



// WEBPACK FOOTER //
// components/shared/StyledImage.js